import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import VesselTypeMasterContent from "../../components/Masters/VesselTypeMaster/VesselTypeMasterContent";

const VesselTypeMaster = () => {
  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <VesselTypeMasterContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default VesselTypeMaster;
